import React, { useState } from "react";
import qs from "query-string";
import { useMutation } from "react-query";

import Widget from "app/components/widget/Widget";
import { useGet, usePost } from "app/services/http-service";
import {
  GET_OPERATOR_CIRCLE_INFO,
  GET_OPERATOR_LIST,
} from "app/api/ApiEndpoints";
import PageWrapper from "app/components/page-wrapper/PageWrapper";
import MobileOperators from "app/components/mobile-operators/MobileOperators";
import { NUMBER_FOR_RECHARGE } from "app/context/Types";
import { StoreContext } from "app/context/Store";
import useAlertConfig from "app/hooks/useAlertConfig";
import Alert from "app/components/alert/Alert";
import { useHistory } from "react-router-dom";

export default function CircleOperatorByNumber(props) {
  const { alertConfig, showFailureAlert } = useAlertConfig(6);
  const mobileNumber = props?.match?.params?.number;
  const context = React.useContext(StoreContext);
  const authToken = localStorage.getItem("tspAuthToken");
  const [step, setStep] = React.useState(2);
  const history = useHistory();

  const [errorCircleOperator, setErrorCircleOperator] = useState(false);

  const {
    mutate: circleOperatorByNumberMutation,
    data: circleOperatorByNumberData,
  } = useMutation((data) => usePost(data),{
    onSuccess:(data)=>{
      if(data?.payload.circleRefID && data?.payload.operatorCode){
        history.push(
          `/recharge/${data?.payload?.operatorCode}/${data?.payload?.circleRefID}/plan?mobileNumber=${mobileNumber}`,
        );
      }
    },
    onError:()=>{
      setErrorCircleOperator(true);
    }
  });
  const { mutate: operatorListMutation, data: operatorListData } = useMutation(
    (data) => useGet(data),{
      onError:(error)=>{
       showFailureAlert(error.message ? error.message : "Something went wrong!");
      }
    }
  );

  const changeStep = (val) => {
    setStep(val);
  };

  React.useEffect(() => {
    const body = {
      url: GET_OPERATOR_CIRCLE_INFO,
      token: authToken,
      data: {
        "phoneNumber":mobileNumber
      },
    };
    circleOperatorByNumberMutation(body);
  }, [circleOperatorByNumberMutation, mobileNumber]);

  React.useEffect(() => {
    const queryParams = {
      page: 0,
      size: 10,
      sortAscending: true,
    };
    const body = {
      url: `${GET_OPERATOR_LIST}?${qs.stringify(queryParams)}`,
      token: authToken,
    };
    operatorListMutation(body);
  }, [operatorListMutation]);

  React.useEffect(() => {
    if (mobileNumber) {
      context.dispatch({
        type: NUMBER_FOR_RECHARGE,
        payload: { ...context.state, rechargeNumber: mobileNumber },
      });
    }
  }, [mobileNumber]);

  return (
    <PageWrapper title="Recharge">
       {alertConfig && (
        <Alert alertMessage={alertConfig.message} status={alertConfig.status} />
      )}
      <div className="row my-4 pay-bills">
        <div className="col-md-3 col-12">
          <Widget
            selectedCategory={context?.state?.selectedCategory}
            step={step}
            changeStep={changeStep}
            selectedBiller={mobileNumber}
          />
        </div>
        <div className="col-md-8 col-12">
          <div className="position_relative">
            <div className="widget-listing">
              <MobileOperators
                changeStep={changeStep}
                mobileNumber={mobileNumber}
                operatorListData={operatorListData}
                circleOperatorByNumberData={circleOperatorByNumberData}
                errorCircleOperator = {errorCircleOperator}
              />
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
}
